import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Button,
  Text,
  useToast,
} from '@chakra-ui/react'
import React from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '../../../services/api'
import { useUser } from '../../../hooks/useUser'

async function retornarVendedorRegraPadrao(codigo_usuario) {
  const response = await api.put(`/site/v2/crm-controle/remover-regras-fila`, {
    codigo_usuario: codigo_usuario,
  })

  return response.data
}

export function RetornarPadrao({ codigoVendedor, nomeVendedor }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { codigo_usuario } = useUser()

  const cancelRef = React.useRef()

  const queryClient = useQueryClient()

  const toast = useToast({
    position: 'top-right',
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: retornarVendedorRegraPadrao,
    onError: (error, variables, context) => {
      console.log(error)

      toast({
        title: 'Erro ao retornar vendedor ao padrão',
        status: 'error',
      })
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries('controle-rodizio')

      toast({
        title: 'Vendedor retornado ao padrão com sucesso',
        status: 'success',
      })

      onClose()
    },
  })

  async function handleRetornarVendedorPadrao() {
    try {
      await mutateAsync(codigo_usuario)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Button mx="auto" colorScheme="red" onClick={onOpen} size="sm">
        P
      </Button>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} size="xl">
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Retornar ao Padrão - {nomeVendedor}
            </AlertDialogHeader>
            <AlertDialogBody>
              <Text>Deseja retornar o vendedor {nomeVendedor} ao padrão de regras da fila?</Text>
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button colorScheme="red" onClick={handleRetornarVendedorPadrao} ml={3} isLoading={isLoading}>
                Retornar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
